import { Step } from "react-joyride";
import JoyrideContent from "./JoyrideContent";

export const homePageProfileNavigationSteps: Step[] = [
  {
    target: "#avatar-menu-target",
    content: (
      <JoyrideContent
        title="Menu"
        description="Access your profile, dashboard, and logout options here."
      />
    ),
  },
  {
    target: "#profile-menu",
    content: (
      <JoyrideContent
        title="Profile"
        description="Access your profile from here."
      />
    ),
    placement: "left",
    locale: {
      last: "Next",
    },
  },
];

export const profilePageStartReviewSteps: Step[] = [
  {
    target: "#start-review",
    content: (
      <JoyrideContent
        title="Start Review"
        description="Click here to begin the review process for your documents."
      />
    ),
    placement: "right",
    locale: {
      last: "Next",
    },
  },
  {
    target: "body",
    disableBeacon: true,
    content: (
      <JoyrideContent
        title="Review Process"
        description="Follow the steps to upload and review your documents."
      />
    ),
    placement: "center",
    locale: {
      last: "Finish",
    },
  },
];
